import CreateDepartamento from './createDepartamento'
import RegisterAccess from '../../../utils/registerAccess'
import HeaderSession from '../../../utils/headerSession'
import CreateSeccao from './createSeccao'
import CreatePerfil from './createPerfil'

export default function GesDepartamentoSeccaoPerfil() {
    return (
        <>
            <RegisterAccess page={''} />
            <HeaderSession title={'GESTÃO DE DEPARTAMENTO, SECÇÃO E PERFIL'} />

            <CreateDepartamento />

            <CreateSeccao />

            <CreatePerfil />
        </>
    )
}
